module.exports = __webpack_public_path__ + "media/images/icons/icon-simulator-modal-d6cb6cdd6f7310f6009403521072aaf6.svg";